export default [
    {
        path: 'fila-atendimento',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-fila-atendimento' */
            '@/views/pronto-atendimento/fila-atendimento/Index'
        ),
        redirect: 'fila-atendimento/index',
        children: [
            {
                name: 'pronto-atendimento-fila-atendimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-fila-atendimento' */
                    '@/views/pronto-atendimento/fila-atendimento/List.vue'
                ),
            },
        ],
    },
]